import {ITimeTableSortKey} from './type';

export function getTimeTableSortingOption(key: ITimeTableSortKey) {
  return key === 'freePublishing'
    ? 'free'
    : key === 'waitForFree'
      ? 'waitfree'
      : key;
}
